import React from 'react';
import styled from 'styled-components';

const Card = styled.div``

const Header = styled.div`
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 20px;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  color: #565656;
  font-size: 14px;
  gap: 15px;
`

const Section = styled.div`
  display: flex;
`

const SectionHeader = styled.div`
  width: 80px;
  color: #080808;
  font-size: 15px;
  min-width: 80px;
`

const SectionCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 150px;
`

export default ({
  orderEx
}) => {
  const order = orderEx.data || {}
  const {
    notifications
  } = order

  return (
    <Card>
      <Header>
        {'Details'}
      </Header>
      <Body>
        <Section>
          <SectionHeader>{'Emails'}</SectionHeader>
          <SectionCol>
            {notifications?.map(n => n).join(', ')}
          </SectionCol>
        </Section>
      </Body>
    </Card>
  )
}